'use client';

import { FC, SVGProps } from 'react';

export interface IconPlusFaqDrawerProps extends SVGProps<SVGSVGElement> {
  open?: boolean;
  darkBackground?: boolean;
}

const IconPlusFaqDrawer: FC<IconPlusFaqDrawerProps> = ({ open, darkBackground, ...props }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" {...props}>
      <path
        d="M16.0003 29.3333C23.3641 29.3333 29.3337 23.3638 29.3337 16C29.3337 8.6362 23.3641 2.66666 16.0003 2.66666C8.63653 2.66666 2.66699 8.6362 2.66699 16C2.66699 23.3638 8.63653 29.3333 16.0003 29.3333Z"
        stroke={`${darkBackground && open
          ? "#DEE948"
          : (darkBackground)
            ? "#FFF"
            : "currentColor"

          }`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {!open && (
        <path
          d="M16 10.6667V21.3333"
          stroke={`${darkBackground ? "#FFF" : "currentColor"}`}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      <path
        d="M10.667 16H21.3337"
        stroke={`${darkBackground && open
          ? "#DEE948"
          : (darkBackground)
            ? "#FFF"
            : "currentColor"

          }`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconPlusFaqDrawer;
